import request from '@/utils/request'
export function getListJ(params) {
	return request.get('audit/index', {
		params
	})
}
export function getListZ(params) {
	return request.get('expert-audit/index', {
		params
	})
}

export function getDetail(params) {
	return request.get('audit/detail', {
		params
	})
}

export function getDetailZ(params) {
	return request.get('expert-audit/applyDetail', {
		params
	})
}

export function getSchoolAdminInfo(params) {
	return request.get('user/school/admin/info', {
		params
	})
}

// 校赛动态
export function getSchoolNoticeList(params) {
	return request.get('audit/dynamics/school/list', {
		params
	})
}
// 省赛动态
export function getProvinceNoticeList(params) {
	return request.get('audit/dynamics/province/list', {
		params
	})
}
// 动态详情
export function getNoticeDetail(params) {
	return request.get('audit/dynamics/detail', {
		params
	})
}